import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {of} from 'rxjs';
import {AppConfig} from "../../../core/conf/main";
import {Events} from "../events";
import {catchError} from "rxjs/operators";


@Injectable()
export class ServerService {

    startSearchIp = AppConfig.startSearchIp;
    dataServerIp = AppConfig.dataServerIp;
    httpServerIp = AppConfig.httpServerIp;
    ver = AppConfig.ver;
    httpstr = AppConfig['http'] ? AppConfig['http'] : 'http://';

    // dataServerIp = 'onebutton.co.il/movingaid/';
    // httpServerIp = 'http://onebutton.co.il/movingaid/';

    constructor(private http: HttpClient, public events: Events) {
    }

    public getEndPoint() {
        return this.httpServerIp;
    }


    public searchDevice(i) {
        return new Promise((resolve, reject) => {
            this.http.get(this.startSearchIp + i + '/ping/', {})
                .subscribe(res => {
                    resolve({'i': i, res: res});
                })
        });
    }


    public download(token, protocolName, filters) {

        return new Promise((resolve, reject) => {
            let httpOptions = {
                headers: new HttpHeaders({
                    'Authorization': token ? "Token " + token : "",
                    'responseType': 'blob',
                    'Content-Type': 'application/json;charset=UTF-8'
                }),
                params: {}
            };

            let url = this.httpstr + this.dataServerIp + "/" + protocolName + "/";
            var str = Object.keys(filters).map(function (key) {
                return key + '=' + filters[key];
            }).join('&');
            url += '?' + str;
            const req = this.http.get(url, httpOptions)
                .pipe(catchError(e => {
                    //console.loge)
                    resolve({'data': false, 'e': e});
                    return of(false);
                }))
            req.subscribe(res => {
                // //console.logres)
                // resolve(res.json());
                if (res)
                    resolve(res);
                else {
                    resolve({'data': {'models': [], 'count': 0}, 'offline': true});
                    reject()
                }
            });

        });
    }

    //An option to talk to other server. for payment e.g.
    public get(token, protocolName, filters, domain = '', httpType = null) {
        let onlineparams = {};
        this.checkOnline(onlineparams);

        // //console.logdomain)
        return new Promise((resolve, reject) => {
            var url;
            if (domain) {
                url = (httpType ? httpType : this.httpstr) + (domain != '' ? domain : this.dataServerIp) + "/" + protocolName;
            } else {
                url = this.httpstr + (domain != '' ? domain : this.dataServerIp) + "/" + protocolName + "/";
            }

            let httpOptions = {};
            if (domain == '') {
                httpOptions = {
                    headers: new HttpHeaders({
                        'Authorization': token ? "Token " + token : "",
                        'Content-Type': 'application/json;charset=UTF-8'
                    }),
                    params: {}
                };
            }
            if(domain.includes('kxcdn.com')){
                filters['k']=Math.floor(Math.random() * Math.floor(1000000))
            }

            var str = Object.keys(filters).map(function (key) {
                return key + '=' + filters[key];
            }).join('&');
            url += '?' + str;

            //let options = new RequestOptions({ headers: myHeaders, params: myParams });
            //let params = new HttpParams().set("paramName",1).set("paramName2", 3); //Create new HttpParams

            const req = this.http.get(url, httpOptions).pipe(catchError(e => {
                //if (e.status === 401) {
                //    return Observable.throw('Unauthorized');
                //}
                ////console.log'catch 1');


                // //console.loge);
                resolve({'data': false, 'e': e});
                return of(false);
                // resolve(false)
                // do any other checking for statuses here
            }));
            req.subscribe(res => {
                ////console.log'login results from server:')
                ////console.logres.data.token);
                onlineparams['online'] = true;

                //let data = res.json();
                // //console.logres);
                ////console.logres._body);
                ////console.logres._body.token);

                //resolve(res);
                // resolve(res.json());
                if (res)
                    resolve(res);
                else {
                    resolve({'data': {'models': [], 'count': 0}, 'offline': true});
                    reject()
                }
            });

        });
    }

    public loadFile(token, url, filters) {
        return new Promise((resolve, reject) => {

            let httpOptions = {};
            httpOptions = {
                headers: new HttpHeaders({
                    'Authorization': token ? "Token " + token : "",
                    'Content-Type': 'application/json;charset=UTF-8'
                }),
                params: filters
            };

            // let headers = new Headers();
            // headers.append('Authorization', token ? "Token " + token : "");
            // headers.append('Content-Type', 'application/json;charset=UTF-8');

            var fullurl = this.httpstr + this.dataServerIp + "/" + url;

            this.http.get(fullurl, httpOptions).subscribe(data => {
                // //console.log'back to heere!!');
                // //console.logdata.text());
                // resolve(data.text()); //tmp remove tmpremove
            })
        });
    }

    public put(token, protocolName, data) {
        let onlineparams = {};
        this.checkOnline(onlineparams);

        return new Promise((resolve, reject) => {
            var url = this.httpstr + this.dataServerIp + "/" + protocolName;

            let httpOptions = {
                headers: new HttpHeaders({
                    'Authorization': token ? "Token " + token : "",
                    'Content-Type': 'application/json;charset=UTF-8'
                })
            };

            //.timeout(20000)
            this.http.put(url, JSON.stringify(data), httpOptions)
                .subscribe(res => {
                    onlineparams['online'] = true;

                    resolve(res);
                }, (err) => {
                    reject(err);
                });
        });

    }

    public post(token, protocolName, data) {
        let onlineparams = {};
        this.checkOnline(onlineparams);

        return new Promise((resolve, reject) => {
            onlineparams['rejecet'] = reject;

            var url = this.httpstr + this.dataServerIp + "/" + protocolName;

            // let headers = new Headers();
            // headers.append('Authorization', token ? "Token " + token : "");
            // headers.append('Content-Type', 'application/json;charset=UTF-8');
            let httpOptions = {
                headers: new HttpHeaders({
                    'Authorization': token ? "Token " + token : "",
                    'Content-Type': 'application/json;charset=UTF-8',
                })
            };

            //.timeout(20000)
            const req = this.http.post(url, JSON.stringify(data), httpOptions)
                .pipe(catchError(e => {
                    //if (e.status === 401) {
                    //    return Observable.throw('Unauthorized');
                    //}
                    // //console.log'catch 1', e);
                    return of(false);
                    // do any other checking for statuses here
                }));
            req.subscribe(res => {

                //let data = res.json();
                // //console.log'subscribe 1')
                // //console.logres);
                ////console.logres._body);
                ////console.logres._body.token);
                //resolve(res);

                onlineparams['online'] = true;

                if (res)
                    resolve(res);
                else
                    reject(false);
            })

        });

    }

    public delete(token, protocolName, filters) {
        return new Promise((resolve, reject) => {
            var url = this.httpstr + this.dataServerIp + "/" + protocolName + "/";

            let httpOptions = {
                headers: new HttpHeaders({
                    'Authorization': token ? "Token " + token : "",
                    'Content-Type': 'application/json;charset=UTF-8'
                }),
                params: filters
            };

            this.http.delete(url, httpOptions)
                .subscribe(res => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
        });
    }

    public upload(token, protocolName, file, filters, data) {
        return new Promise((resolve, reject) => {
            var f = [];

            for (var key in filters) {
                f.push(key + '=' + filters[key]);
            }

            var params = {};
            for (var key in data) {
                if (data[key]) {
                    params[key] = data[key];
                }
            }


            var url = this.httpstr + this.dataServerIp + "/" + protocolName + "/?" + f.join("&");

            //url: url,
            //data: params,
            //sendFieldsAs: 'form',

            let httpOptions = {};
            httpOptions = {
                headers: new HttpHeaders({
                    'Authorization': token ? "Token " + token : "",
                    'Content-Type': 'application/octet-stream',
                    'Upload-Content-Type': 'png'
                }),
                params: filters
            };

            // let headers = new HttpHeaders();
            // headers.append('Authorization', token ? "Token " + token : "");
            // //headers.append('Content-Type', 'multipart/form-data');
            // headers.set('Content-Type', 'application/octet-stream');
            // headers.set('Upload-Content-Type', 'png')

            var blob = this.dataURItoBlob(file.src);
            var fd = new FormData(document.forms[0]);

            params['file'] = blob;
            // //console.logparams)

            this.http.post(url, params, httpOptions)
                .subscribe(res => {
                    // resolve(res.json()); //tmpremove
                }, (err) => {
                    reject(err);
                });


        });
    }

    dataURItoBlob(dataURI) {
        // convert base64/URLEncoded data component to raw binary data held in a string
        var byteString;
        if (dataURI.split(',')[0].indexOf('base64') >= 0)
            byteString = atob(dataURI.split(',')[1]);
        else {
            // unescape
            byteString = dataURI.split(',')[1];
        }

        // separate out the mime component
        var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

        // write the bytes of the string to a typed array
        var ia = new Uint8Array(byteString.length);
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }

        return new Blob([ia], {type: mimeString});
    }

    getHost() {
        return '10.100.102.8:82'
    }

    public getVersion() {
        return this.ver;
    }

    public checkOnline(params) {
        return
        let me = this;
        setTimeout(function () {
            if (!params['online']) {
                //console.log"OFFLINEEEEE!!!")
                me.events.publish('setLoadingOffline');

                if (params['rejecet'])
                    params['rejecet']();
            }
        }, 9000);
    }
}
